module.exports = __webpack_public_path__ + "static/media/logo-licitacoese.824c7bea.png";